import { createIntl, createIntlCache, FormattedMessage } from 'react-intl';
import French from '../../../lang/fr.json';
import English from '../../../lang/en.json';
import { COUNTRY } from '../../environment';

const cache = createIntlCache();

let locale = 'en';

if (typeof window !== 'undefined') {
  const storedLocale = localStorage.getItem('locale');
  if (storedLocale) {
    locale = storedLocale;
  }
}

const messages = locale === 'en' ? English : French;

// Always defined singleton
export const intl = createIntl({ locale, messages }, cache);
export const { formatMessage } = intl;

export const INTRODUCTION = -1;
export const PERSONAL_DETAILS = 0;
export const PRACTICE_DETAILS = 1;
export const LOCATION_DETAILS = COUNTRY === 'CA' ? 2 : 1;
export const MATCHING_PREFERENCES = COUNTRY === 'CA' ? 3 : 2;
export const TAX_INFORMATION = 4;
export const THANK_YOU = COUNTRY === 'CA' ? 5 : 3;

export const steppers = buildSteppers();

function buildSteppers() {
  /* eslint-disable no-shadow */
  const steppers = [
    {
      label: formatMessage({ defaultMessage: 'Personal Details' }),
      value: PERSONAL_DETAILS,
    },
    {
      label: formatMessage({ defaultMessage: 'Location Details' }),
      value: LOCATION_DETAILS,
    },
    {
      label: formatMessage({ defaultMessage: 'Matching Preferences' }),
      value: MATCHING_PREFERENCES,
    },
  ];

  if (COUNTRY === 'CA') {
    steppers.splice(1, 0, {
      label: formatMessage({ defaultMessage: 'Practice Details' }),
      value: PRACTICE_DETAILS,
    });
    steppers.push({
      label: formatMessage({ defaultMessage: 'Tax Information' }),
      value: TAX_INFORMATION,
    });
  }

  return steppers;
}
